import { useAuthStore } from '~/store/auth.store';

/** Internal staff domain — same precedent as `useCanChooseRetailerPrompt`. */
const INTERNAL_EMAIL_DOMAIN = '@lily.ai';

/**
 * Whether the user may pick a different file transformer when exporting or
 * delivering (super admin or `@lily.ai`). Customers see the assigned layout
 * read-only and never send `transformerId` (the API answers 403 if they do).
 */
export function useCanChooseFileLayout(): boolean {
  return useAuthStore((s) => {
    const user = s.user;
    if (!user) return false;
    return user.isSuperAdmin || user.email.toLowerCase().endsWith(INTERNAL_EMAIL_DOMAIN);
  });
}
